import { computed, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';

@Injectable({ providedIn: 'root' })

export class ShowComponentService {
    private _customRouteService: CustomRouteService = inject(CustomRouteService);

    private _router = inject(Router);
    private _routeToken =  this._customRouteService.token;
    
    showMapComponent(){
        const actualRoute = this._router.url;
        console.log("DEBUG: actualRoute", actualRoute);
        if (actualRoute.includes('/route/'))
            return {
                'is_successful': false,
                'reason': 'Ya estás en la vista de la ruta'
            }

        this._router.navigateByUrl(`/home/route/${this._routeToken()}`);
        return {
            'is_successful': true
        }
    }
}